/**
 * Notification API functions for tenant portal
 */

import { tenantApi } from './client';
import type { NotificationListResponse, UnreadCountResponse } from '@intellimon/shared/types';

export interface NotificationQueryParams {
  page?: number;
  page_size?: number;
  type?: string;
  priority?: string;
}

export async function getNotifications(
  params: NotificationQueryParams = {}
): Promise<NotificationListResponse> {
  const response = await tenantApi.get<NotificationListResponse>('/notifications', { params });
  return response.data;
}

export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const response = await tenantApi.get<UnreadCountResponse>('/notifications/unread-count');
  return response.data;
}

export async function markAsRead(notificationId: string): Promise<void> {
  await tenantApi.post(`/notifications/${notificationId}/read`);
}

export async function markAllAsRead(): Promise<void> {
  await tenantApi.post('/notifications/read-all');
}
